import React from "react";
import PropTypes from "prop-types";
import { MenuButton } from "../styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUnlink } from "@fortawesome/pro-solid-svg-icons";

UnlinkButton.propTypes = {
  editor: PropTypes.object,
  disabled: PropTypes.bool,
};

export default function UnlinkButton({ editor, disabled = false }) {
  return (
    <MenuButton
      onClick={() => editor.chain().focus().unsetLink().run()}
      disabled={disabled || !editor.isActive("link")}
    >
      <FontAwesomeIcon icon={faUnlink} />
    </MenuButton>
  );
}
